import { Link } from "react-router-dom";
import { useSiteContent } from "@/hooks/useSiteContent";
import Wordmark from "@/components/Wordmark";

const Footer = () => {
  const { t } = useSiteContent();
  return (
    <footer className="bg-background border-t border-border">
      <div className="container py-12 flex flex-col md:flex-row items-center justify-between gap-6">
        <Wordmark size="sm" asLink />
        <p className="text-sm text-muted-foreground text-center">
          {t("footer.tagline", "Celebrating emerging female athletes.")} © {new Date().getFullYear()}
        </p>
        <div className="flex flex-wrap gap-x-4 text-sm font-medium items-center justify-center">
          <Link to="/become-an-athlete" className="inline-flex items-center min-h-[44px] px-1 rounded-full hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary">
            Become a SIIS Athlete
          </Link>
          <a
            href="https://instagram.com/sayitinsports"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center min-h-[44px] px-1 rounded-full hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
          >
            Instagram
          </a>
          
          <Link to="/privacy" className="inline-flex items-center min-h-[44px] px-1 rounded-full hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary">
            Privacy &amp; analytics
          </Link>
          <a
            href="https://sayitinsports.beehiiv.com/subscribe"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center min-h-[44px] px-1 rounded-full hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
          >
            Subscribe to SIIS Weekly
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
